import { AbstractBuilder } from './AbstractBuilder'

interface CtorWithArgs<T> {
  new (...ctorArgs: unknown[]): T
  prototype: Object
}

export abstract class AbstractClassBuilder<TResult extends {}> extends AbstractBuilder<TResult> {
  protected constructor(construct: CtorWithArgs<TResult>, partial: Partial<TResult>) {
    super(new construct())
    this.with(partial)
  }
}
